export default __webpack_public_path__ + "static/media/Website_Mobile.4736d263.svg";